'use client';

import { Button, CircularProgress, Grid, InputLabel, TextField } from '@mui/material';
import { InverseButton } from '@parkchirp/ui-library';
import React, { Dispatch, FC, SetStateAction } from 'react';

interface Props {
	setTabValue: Dispatch<SetStateAction<string>>;
	accessLevel: string;
	setAccessLevel: Dispatch<SetStateAction<string>>;
	setActiveStep: Dispatch<SetStateAction<number>>;
	submitRate: () => void;
	loading: boolean;
	isChild: boolean;
	theme: any;
}

const AccessSystem: FC<Props> = ({
	setTabValue,
	accessLevel,
	setAccessLevel,
	setActiveStep,
	submitRate,
	loading,
	isChild,
	theme,
}) => (
	<Grid className='pca__ratesForm-containerPadding' spacing={2} container>
		<Grid item xs={12}>
			<InputLabel>Access Level</InputLabel>
			<TextField
				fullWidth
				value={accessLevel}
				disabled={isChild}
				onChange={(e) => setAccessLevel(e.target.value)}
				inputProps={{ 'data-cy': 'access-level-input' }}
			/>
		</Grid>
		<Grid item xs={6}>
			<InverseButton
				fullWidth
				onClick={() => {
					setTabValue(isChild ? '6' : '5');
					setActiveStep(isChild ? 5 : 4);
				}}
				data-cy='previous-button'
				name='Previous'
				theme={theme}
			/>
		</Grid>
		<Grid item xs={6}>
			<Button fullWidth onClick={submitRate} disabled={loading} data-cy='submit-rate-button'>
				Submit Rate
				{loading ? (
					<CircularProgress color='inherit' size={20} data-cy='submit-rate-loading-indicator' />
				) : null}
			</Button>
		</Grid>
	</Grid>
);

export default AccessSystem;
